module.exports = __webpack_public_path__ + "static/img/DeluxeDoubleRoom3.14245816.jpg";